interface ExportBridge { exportProgress(options: { json: string }): Promise<{ saved: boolean; cancelled?: boolean }> }
export async function saveProgressFile(json: string, android: boolean, native: ExportBridge, download: (json: string) => void): Promise<'saved' | 'cancelled' | 'downloaded'> {
  if (!android) { download(json); return 'downloaded'; }
  const result = await native.exportProgress({ json });
  if (result.saved === true) return 'saved';
  if (result.cancelled === true) return 'cancelled';
  throw new Error('Export did not finish');
}
